import React from 'react';
//import { Router, Route } from "react-router";
// import createHistory from 'history/createHashHistory';
import Users from './pk/Admin'
import BottomNav from './pk/SimpleBottomNavigation'
import 'bootstrap/dist/css/bootstrap.min.css';

// const history = createHistory();

const App = () => (
  <div>
    <Users ></Users>
    <BottomNav />
  </div>
);

export default App;
